import { basicEnum } from "./base";

export const DisbursementBankCodeEnum = basicEnum([
    {
        label: "Bank Mandiri",
        value: "MANDIRI",
    },
    {
        label: "Bank Rakyat Indonesia (BRI)",
        value: "BRI",
    },
    {
        label: "Bank Negara Indonesia (BNI)",
        value: "BNI",
    },
    {
        label: "Bank Tabungan Negara (BTN)",
        value: "BTN",
    },
    {
        label: "Bank Syariah Indonesia (BSI)",
        value: "BSI",
    },
    {
        label: "Bank Central Asia (BCA)",
        value: "BCA",
    },
    {
        label: "DANA",
        value: "DANA",
    },
    {
        label: "GoPay",
        value: "GOPAY",
    },
    {
        label: "OVO",
        value: "OVO",
    },
    {
        label: "ShopeePay",
        value: "SHOPEEPAY",
    },
]);

export namespace DisbursementBankCodeEnum {
    export type Labels = (typeof DisbursementBankCodeEnum)["labels"][number];
    export type Values = (typeof DisbursementBankCodeEnum)["values"][number];
}
